'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getOrderPaymentMethodInfoEndpoint = exports.getOrderPaymentMethodInfoEndpoint = function getOrderPaymentMethodInfoEndpoint() {
  return 'Order/Payment:methodInfo';
};